/* eslint-disable @typescript-eslint/no-namespace */
import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

// Define environment variable type
declare global {
  namespace NodeJS {
    interface ProcessEnv {
      REACT_APP_API_URL: string;
    }
  }
}

const API_URL: string = process.env.REACT_APP_API_URL;

// production server
export const api: AxiosInstance = axios.create({
  baseURL: API_URL,
});

// Global response interceptor for authentication errors
api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Clear authentication data
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Redirect to login page
      window.location.href = '/';

      // Show notification (if toast system is available)
      if (window.location.pathname !== '/') {
        // Simple alert as fallback - in production, use toast system
        alert('Your session has expired. Please login again.');
      }
    }

    return Promise.reject(error);
  }
);

export const apiUrl: string = API_URL;

// aws s3 bucket configurations
export const awsRegion: string = 'eu-central-1';
export const awsIdentityPoolId: string = 'eu-central-1:949b9487-ed35-4eb3-a2d3-1866e6ad890b';
export const awsBucket: string = 'avangrat-development';
